var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-12"},[_c('a',{staticClass:"anchor",attrs:{"id":"exhibitionFormTitle"}}),_c('h2',{staticClass:"text-center text-uppercase"},[_c('i',{staticClass:"fas fa-square"}),_vm._v("\n    "+_vm._s(_vm.formTitle)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }